import translations from "@/config/translations";
import useLangStore from "@/hooks/useLangStore";
import "./styles.css";

// ── Icons ─────────────────────────────────────────────────────────────────────

const CheckIcon = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <polyline points="1.5,5 3.8,7.5 8.5,2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CenterIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="3" y="26" width="8" height="18" rx="3" fill="white" opacity="0.4" />
        <rect x="20" y="17" width="8" height="27" rx="3" fill="white" opacity="0.65" />
        <rect x="37" y="6" width="8" height="38" rx="3" fill="white" />
        <path d="M3 22l10-9 8 6 10-12 12 8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.65" />
    </svg>
);

// ── Component ─────────────────────────────────────────────────────────────────

export default function HomeScreen() {
    const { lang } = useLangStore();
    const t = translations[lang ?? "ar"];
    const h = t.homeScreen;

    const activeScreens = [
        t.nav.products,
        t.nav.categories,
        t.nav.branches,
        t.nav.tiers,
        t.nav.challenges,
        t.nav.customers,
        t.nav.orders,
        t.nav.clients,
    ];

    return (
        <div className="home-screen">
            {/* ── Decoration ── */}
            <div className="home-deco">
                <div className="home-deco-ring home-deco-ring--outer" />
                <div className="home-deco-ring home-deco-ring--mid" />
                <div className="home-deco-core">
                    <CenterIcon />
                </div>
            </div>

            {/* ── Live + Title ── */}
            <div className="home-live-row">
                <span className="home-live-dot" />
                <span className="home-live-label">{h.live}</span>
            </div>
            <h1 className="home-title">{h.title}</h1>
            <p className="home-subtitle">{h.subtitle}</p>

            {/* ── Active screens pills ── */}
            <div className="home-pills">
                {activeScreens.map((name) => (
                    <span key={name} className="home-pill">
                        <CheckIcon />
                        {name}
                    </span>
                ))}
            </div>
        </div>
    );
}
